// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b9f9d1ce","171":"81bf3048","238":"6c7aaf95","473":"598c0ccb"}[chunkId] + ".chunk.js";
};